export type OrigenCredenciales = "guardadas" | "manual";

interface FormularioCredencialesProps {
  origenCredenciales: OrigenCredenciales;
  setOrigenCredenciales: (origen: OrigenCredenciales) => void;
  tieneCredencialesGuardadas: boolean;
  usuarioGuardado: string;
  urlGuardada: string;

  username: string;
  password: string;
  setUsername: (username: string) => void;
  setPassword: (password: string) => void;
  url: string;
  setUrl: (url: string) => void;
  guardarCredenciales: boolean;
  setGuardarCredenciales: (value: boolean) => void;
}

const FormularioCredencialesSUNAT = ({
  origenCredenciales,
  setOrigenCredenciales,
  tieneCredencialesGuardadas,
  usuarioGuardado,
  urlGuardada,
  username,
  password,
  setUsername,
  setPassword,
  url,
  setUrl,
  guardarCredenciales,
  setGuardarCredenciales,
}: FormularioCredencialesProps) => {

  // --- ESTILOS REUTILIZABLES ---
  const inputClass = "w-full bg-[rgb(var(--c-surface))] border border-white/10 rounded-xl p-3 text-white focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all placeholder:text-gray-500 mb-1 mt-1";
  const labelClass = "block text-xs font-bold text-blue-400 uppercase tracking-wider mb-2 mt-4 ml-1";

  return (
    <div className="animate-fadeIn">
      <form className="space-y-1">
        {/* ORIGEN DE CREDENCIALES */}
        <label className={labelClass}>Origen de credenciales</label>
        <select
          className={inputClass}
          value={origenCredenciales}
          onChange={(e) => setOrigenCredenciales(e.target.value as OrigenCredenciales)}
        >
          {tieneCredencialesGuardadas && (
            <option value="guardadas" className="bg-[rgb(var(--c-surface))]">Usar credenciales guardadas</option>
          )}
          <option value="manual" className="bg-[rgb(var(--c-surface))]">Ingresar manualmente</option>
        </select>

        {origenCredenciales === "guardadas" ? (
          <p className="text-xs text-gray-400 bg-white/5 border border-white/10 rounded-xl p-3 mt-1">
            Se usarán las credenciales SUNAT guardadas para este cliente{usuarioGuardado ? ` (${usuarioGuardado})` : ''}
            {urlGuardada ? ` y la URL de servicio guardada (${urlGuardada})` : ''}.
          </p>
        ) : (
          <div className="animate-slideInRight space-y-1">
            <label className={labelClass}>Usuario SUNAT</label>
            <input
              type="text"
              className={inputClass}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ej: user123"
              required
            />

            <label className={labelClass}>Contraseña SUNAT</label>
            <input
              type="password"
              className={inputClass}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />

            <label className={labelClass}>URL del Servicio SUNAT (opcional)</label>
            <input
              type="text"
              className={inputClass}
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Dejar en blanco para usar la URL por defecto"
            />

            <label className="flex items-center gap-2 text-sm text-gray-300 cursor-pointer mt-2 ml-1">
              <input
                type="checkbox"
                checked={guardarCredenciales}
                onChange={(e) => setGuardarCredenciales(e.target.checked)}
                className="w-4 h-4 rounded border-white/10 bg-zinc-800 accent-blue-500"
              />
              Guardar estas credenciales para este cliente
            </label>
          </div>
        )}
      </form>
    </div>
  );
};

export default FormularioCredencialesSUNAT;
